/**
 * Resolve the lightboard id from a reducer payload.
 * Callers historically mixed `lightboardID` and `id`.
 * @param {Object} payload
 * @returns {string|undefined}
 */
export default function getLightboardId(payload) {
  return payload?.lightboardID || payload?.id;
}
